document
  .querySelectorAll('.prd-DetailForm_Option.prd-DetailForm_Option-colour')
  .forEach((option) =>
    option.addEventListener('click', function (e) {
      const colourChosen = e.currentTarget.dataset.productOptionValue.trim();
      colourSwatchLabels.forEach((label) => (label.innerHTML = colourChosen));

      const colourToShow = e.currentTarget.dataset.productOptionValue;

      if (!document.querySelector('#data')) return;
      const JSONData = JSON.parse(document.querySelector('#data').innerHTML);

      const selectedColourImages = JSONData[colourToShow];

      if (!selectedColourImages) return;

      if (isMobileDevice()) {
        handleMobile(selectedColourImages);
      } else {
        handleDesktop(selectedColourImages);
      }
    })
  );

const isMobileDevice = () => window.innerWidth <= 768;

const handleMobile = (selectedColourImages) => {
  const newImageSlides = [];

  selectedColourImages.forEach((image) =>
    newImageSlides.push(`
      <div class="swiper-slide">
        <img 
          loading="eager"
          width="100%"
          height
          src="${image}&transform=resize=500x500"
          alt=""
        />
      </div>
    `)
  );

  if (newImageSlides.length > 0) {
    variantGallery.removeAllSlides();
    variantGallery.prependSlide(newImageSlides);
  }
};

const handleDesktop = (selectedColourImages) => {
  if (!document.querySelector('#Product_ImageWrapper--desktop')) {
    return;
  }
  const imageContainer = document.querySelector(
    '#Product_ImageWrapper--desktop'
  );

  const newImageSlides = [];

  selectedColourImages.forEach((image, index) =>
    newImageSlides.push(`
      <div
        class="prd-Product_GridItem prd-Product_GridItem-image js-Product_ImageItem prd-Product_GridItem-hideImage js-MediaGallery_Trigger"
        data-img-position="${index}"
        data-product-image="${image.id}"
        data-media-trigger="${image.id}"
      >
        <img
          loading="lazy"
          width
          height
          src="${image}&transform=resize=500x500"
          alt=""
        >
      </div>
    `)
  );

  imageContainer.innerHTML = newImageSlides.join('');
};
